"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const _emailUtils = require("~/utils/emailUtils");
const BATCH_SIZE = 5000;
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.USERS, (table)=>{
        table.string('canonical_email');
        table.index('canonical_email');
    });
    // Backfill canonical_email in batches
    // eslint-disable-next-line no-constant-condition
    while(true){
        const users = await knex(_globals.MetaTable.USERS).select('id', 'email').whereNull('canonical_email').whereNotNull('email').limit(BATCH_SIZE);
        if (users.length === 0) break;
        // Group by canonical value to batch updates where possible
        const updatesByCanonical = new Map();
        for (const user of users){
            const canonical = (0, _emailUtils.normalizeEmail)(user.email);
            if (!updatesByCanonical.has(canonical)) {
                updatesByCanonical.set(canonical, []);
            }
            updatesByCanonical.get(canonical).push(user.id);
        }
        for (const [canonical, ids] of updatesByCanonical){
            await knex(_globals.MetaTable.USERS).whereIn('id', ids).update({
                canonical_email: canonical
            });
        }
    }
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.USERS, (table)=>{
        table.dropColumn('canonical_email');
    });
};
